// packages
import React from "react";
import * as Router from "react-router-dom";
// data
import * as XLSX from "xlsx";
// UI
import * as MUI from "@mui/material";
import * as MLab from "@mui/lab";
import * as MIcons from "@mui/icons-material";
// models
import { MyAppM } from "../models/MyAppM";
import * as MZ from "../models/MZ";
import * as mz from "../models/mz/mz";
// layouts
import MyPage from "../layouts/MyPage";
// components
import MyTable from "../components/MyTable";
import MyFormDialog from "../components/MyFormDialog";
import MyDataTable from "../components/MyDataTable";
import MyWrap from "../components/MyWrap";
import MyFilePicker from "../components/MyFilePicker";

const MyScheduledReports = () => {
  const RouterNavigate = Router.useNavigate();
  // const RouterLocation = Router.useLocation();
  // const RouterParams = Router.useParams();
  // ui
  const [apiError, setApiError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [dependants, setDependants] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [addFormOpen, setAddFormOpen] = React.useState(false);

  // check if logged in
  React.useLayoutEffect(() => {
    if (MyAppM.checkUIDD() === false) RouterNavigate("/");
    (async () => {
      // data
      var r = await dependantsAPI();
      setLoading(false);
      if (r.success === false) {
        setApiError(r.message);
      } else {
        setApiError(null);
        setDependants(r.data["data"]);
      }
    })();
    // (async () => {
    //   // data
    //   var r = await getAPI();
    //   setLoading(false);
    //   if (r.success === false) {
    //     setApiError(r.message);
    //   } else {
    //     setApiError(null);
    //     setData(r.data["data"]["transactions"]);
    //   }
    // })();
  }, []);

  return (
    <MyPage>
      {MZ.If(
        !!apiError,
        <MUI.Alert severity="error" sx={{ m: 3 }}>
          {apiError}
        </MUI.Alert>
      )}
      <MyDataTable
        sx={{ p: 1 }}
        small={true}
        loading={loading}
        title={MZ.T("scheduled-reports")}
        titleActions={[
          {
            icon: "",
            text: MZ.T("add"),
            props: { variant: "outlined" },
            onClick: () => setAddFormOpen(true),
          },
        ]}
        columns={[
          {
            key: "property_id",
            head: MZ.T("property"),
            value: (k, v) => v.property_name,
          },
          {
            key: "outlet_id",
            head: MZ.T("outlet"),
            value: (k, v) => v.outlet_name,
          },
          {
            key: "occurrence",
            head: MZ.T("occurrence"),
            value: (k, v) => v.occourence,
          },
          {
            key: "users",
            head: MZ.T("users"),
            value: (k, v) => v.users,
          },
        ]}
        data={data ?? []}
      />
      <MyAddForm
        open={addFormOpen}
        setOpen={setAddFormOpen}
        loading={loading}
        setLoading={setLoading}
        dependants={dependants}
        apiError={apiError}
      />
    </MyPage>
  );
};

export default MyScheduledReports;

//============< filterForm
const MyAddForm = (props) => {
  // const
  const RouterParams = Router.useParams();
  // form
  var formController = MZ.FormController();
  const [oExp, setOExp] = React.useState(0);
  const [occ, occ_set] = React.useState("once");
  //
  return (
    <MyFormDialog
      open={props.open}
      title={MZ.T("add")}
      onSubmit={(form) => {
        props.setLoading(true);
        props.setFilterExport(formController.export());
        props.setFilterData(formController.toObj());
        props.setOpen(false);
      }}
      maxWidth="md"
      actions={[
        <MLab.LoadingButton
          key={MZ.GetKey()}
          startIcon={<MIcons.Close />}
          loading={false}
          loadingPosition="start"
          type="cancel"
          variant="contained"
          onClick={() => {
            props.setOpen(false);
          }}
        >
          {MZ.T("cancel")}
        </MLab.LoadingButton>,
        <MLab.LoadingButton
          key={MZ.GetKey()}
          startIcon={<MIcons.Send />}
          loading={props.loading}
          loadingPosition="start"
          type="submit"
          variant="contained"
        >
          {MZ.T("go")}
        </MLab.LoadingButton>,
      ]}
    >
      {MZ.If(
        !!props.apiError,
        <MUI.Alert severity="error" sx={{ m: 3, mt: 0 }}>
          {props.apiError}
        </MUI.Alert>
      )}
      <MUI.Grid
        container
        direction="row"
        spacing={1}
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{ mb: 3 }}
      >
        <MUI.Grid item xs={12} sm={6} md={4}>
          <MZ.InputControllerWidget
            name="occurrence"
            initValue="once"
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.FormControl fullWidth>
                <MUI.InputLabel id="filter-occurrence">
                  {MZ.T("occurrence")}
                </MUI.InputLabel>
                <MUI.Select
                  labelId="filter-occurrence"
                  className="w100"
                  label={MZ.T("occurrence")}
                  name="occurrence"
                  value={value}
                  onChange={(evt) => {
                    setValue(evt.target.value);
                    occ_set(evt.target.value);
                  }}
                >
                  <MUI.MenuItem value="once">{MZ.T("once")}</MUI.MenuItem>
                  <MUI.MenuItem value="daily">{MZ.T("daily")}</MUI.MenuItem>
                  <MUI.MenuItem value="weekly">{MZ.T("weekly")}</MUI.MenuItem>
                  <MUI.MenuItem value="monthly">{MZ.T("monthly")}</MUI.MenuItem>
                  <MUI.MenuItem value="yearly">{MZ.T("yearly")}</MUI.MenuItem>
                </MUI.Select>
              </MUI.FormControl>
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MZ.GroupControllerWidget
            formController={formController}
            name="users"
            inputField={(values) => {
              let checks = MZ.CountIf(values, (k, v) => v === true);
              let count = Object.keys(values).length;
              return (
                <MUI.FormControlLabel
                  label={MZ.T("users")}
                  control={
                    <MUI.Checkbox
                      checked={checks === count}
                      indeterminate={checks > 0 && checks < count}
                      onChange={(evt) =>
                        formController.setValues("users", evt.target.checked)
                      }
                    />
                  }
                />
              );
            }}
          />
          <MUI.Stack
            direction="row"
            justifyContent="flex-start"
            flexWrap="wrap"
            sx={{ pl: 3 }}
          >
            {!props.dependants
              ? null
              : MZ.ForEach(props.dependants["users"], (k, v) => (
                  <MZ.InputControllerWidget
                    key={`users-${k}`}
                    formController={formController}
                    name="users"
                    index={parseInt(k)}
                    initValue={true}
                    staticValue={v["id"]}
                    inputField={(value, setValue, error) => (
                      <MUI.FormControlLabel
                        label={v["name"]}
                        control={
                          <MUI.Checkbox
                            checked={value}
                            onChange={(evt) => setValue(evt.target.checked)}
                          />
                        }
                      />
                    )}
                  />
                ))}
          </MUI.Stack>
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        <MUI.Grid item xs={12} sm={6} md={4}>
          <MZ.InputControllerWidget
            name="milestone"
            initValue="daily"
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.FormControl fullWidth>
                <MUI.InputLabel id="filter-milestone">
                  {MZ.T("milestone")}
                </MUI.InputLabel>
                <MUI.Select
                  labelId="filter-milestone"
                  className="w100"
                  label={MZ.T("milestone")}
                  name="milestone"
                  value={value}
                  onChange={(evt) => setValue(evt.target.value)}
                >
                  <MUI.MenuItem value="daily">{MZ.T("daily")}</MUI.MenuItem>
                  <MUI.MenuItem value="weekly">{MZ.T("weekly")}</MUI.MenuItem>
                  <MUI.MenuItem value="monthly">{MZ.T("monthly")}</MUI.MenuItem>
                </MUI.Select>
              </MUI.FormControl>
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6} md={4}>
          <MZ.InputControllerWidget
            name="first_weekday"
            initValue={0}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.FormControl fullWidth>
                <MUI.InputLabel id="filter-fdw">
                  {MZ.T("first-weekday")}
                </MUI.InputLabel>
                <MUI.Select
                  labelId="filter-fdw"
                  className="w100"
                  label={MZ.T("first-weekday")}
                  name="first_weekday"
                  value={value}
                  onChange={(evt) => setValue(evt.target.value)}
                >
                  <MUI.MenuItem value={0}>{MZ.T("sunday")}</MUI.MenuItem>
                  <MUI.MenuItem value={1}>{MZ.T("monday")}</MUI.MenuItem>
                  <MUI.MenuItem value={2}>{MZ.T("tuesday")}</MUI.MenuItem>
                  <MUI.MenuItem value={3}>{MZ.T("wednesday")}</MUI.MenuItem>
                  <MUI.MenuItem value={4}>{MZ.T("thursday")}</MUI.MenuItem>
                  <MUI.MenuItem value={5}>{MZ.T("friday")}</MUI.MenuItem>
                  <MUI.MenuItem value={6}>{MZ.T("saturday")}</MUI.MenuItem>
                </MUI.Select>
              </MUI.FormControl>
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6} md={4}>
          <MZ.InputControllerWidget
            name="currency"
            formController={formController}
            initValue="usd"
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                select
                label={MZ.T("currency")}
                name="currency"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
              >
                <MUI.MenuItem value="usd">
                  {MZ.T("default-currency")}
                </MUI.MenuItem>
                {!props.dependants
                  ? null
                  : MZ.ForEach(props.dependants["currencies"], (k, v) => (
                      <MUI.MenuItem
                        key={`FCO-${k}`}
                        value={v.id}
                        children={v.name}
                      />
                    ))}
              </MUI.TextField>
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>
        <MUI.Grid item xs={12}>
          <MUI.Stack
            direction="row"
            justifyContent="space-evenly"
            flexWrap="wrap"
          >
            <MZ.InputControllerWidget
              name="extras"
              index={0}
              initValue={false}
              staticValue="avgWeekdays"
              formController={formController}
              inputField={(value, setValue, error) => (
                <MUI.FormControlLabel
                  control={
                    <MUI.Switch
                      checked={value}
                      onChange={(evt) => setValue(evt.target.checked)}
                    />
                  }
                  label={MZ.T("weekdays-average")}
                />
              )}
            />
            <MZ.InputControllerWidget
              name="extras"
              index={1}
              initValue={false}
              staticValue="totalWeekdays"
              formController={formController}
              inputField={(value, setValue, error) => (
                <MUI.FormControlLabel
                  control={
                    <MUI.Switch
                      checked={value}
                      onChange={(evt) => setValue(evt.target.checked)}
                    />
                  }
                  label={MZ.T("weekdays-total")}
                />
              )}
            />
            <MZ.InputControllerWidget
              name="extras"
              index={2}
              initValue={false}
              staticValue="compareWeekdays"
              formController={formController}
              inputField={(value, setValue, error) => (
                <MUI.FormControlLabel
                  control={
                    <MUI.Switch
                      checked={value}
                      onChange={(evt) => setValue(evt.target.checked)}
                    />
                  }
                  label={MZ.T("compare-weekdays")}
                />
              )}
            />
          </MUI.Stack>
        </MUI.Grid>
        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        {RouterParams.portal === "outlet" ? null : (
          <MUI.Grid item xs={12}>
            <MZ.GroupControllerWidget
              formController={formController}
              name="outlets"
              inputField={(values) => {
                let checks = MZ.CountIf(values, (k, v) => v === true);
                let count = Object.keys(values).length;
                return (
                  <MUI.FormControlLabel
                    label={MZ.T(
                      RouterParams.portal === "corporate"
                        ? "properties"
                        : "outlets"
                    )}
                    control={
                      <MUI.Checkbox
                        checked={checks === count}
                        indeterminate={checks > 0 && checks < count}
                        onChange={(evt) =>
                          formController.setValues(
                            "outlets",
                            evt.target.checked
                          )
                        }
                      />
                    }
                  />
                );
              }}
            />
            {props.dependants
              ? MZ.ForEach(props?.dependants?.outlets, (k, v) => {
                  let key = `outletFilter-${k}`;
                  return (
                    <MUI.Accordion key={key} expanded={oExp === k}>
                      <MUI.AccordionSummary
                        expandIcon={
                          <MIcons.ExpandMore
                            onClick={() => setOExp(oExp === k ? null : k)}
                            sx={{
                              pointerEvents: "auto",
                            }}
                          />
                        }
                        sx={{
                          pointerEvents: "none",
                        }}
                      >
                        <MZ.InputControllerWidget
                          formController={formController}
                          name="outlets"
                          index={parseInt(k)}
                          initValue={true}
                          staticValue={v.id}
                          inputField={(value, setValue, error) => (
                            <MUI.FormControlLabel
                              sx={{
                                pointerEvents: "auto",
                              }}
                              label={v.name}
                              control={
                                <MUI.Checkbox
                                  checked={value}
                                  onChange={(evt) =>
                                    setValue(evt.target.checked)
                                  }
                                />
                              }
                            />
                          )}
                        />
                      </MUI.AccordionSummary>
                      <MUI.AccordionDetails sx={{ pl: 3 }}>
                        <MZ.GroupControllerWidget
                          formController={formController}
                          name={`benchmarks-${v.id}`}
                          inputField={(values) => {
                            let checks = MZ.CountIf(
                              values,
                              (k, v) => v === true
                            );
                            let count = Object.keys(values).length;
                            return (
                              <MUI.FormControlLabel
                                label={MZ.T("benchmarks")}
                                control={
                                  <MUI.Checkbox
                                    checked={checks === count}
                                    indeterminate={checks > 0 && checks < count}
                                    onChange={(evt) =>
                                      formController.setValues(
                                        `benchmarks-${v.id}`,
                                        evt.target.checked
                                      )
                                    }
                                  />
                                }
                              />
                            );
                          }}
                        />
                        <MUI.Stack
                          direction="row"
                          justifyContent="flex-start"
                          flexWrap="wrap"
                          sx={{ pl: 3 }}
                        >
                          {MZ.ForEach(props?.dependants?.outlets, (k2, v2) => {
                            if (k === k2) return;
                            return (
                              <MZ.InputControllerWidget
                                key={`${key}-${k2}`}
                                formController={formController}
                                name={`benchmarks-${v.id}`}
                                index={parseInt(k2)}
                                initValue={true}
                                staticValue={v2.id}
                                inputField={(value, setValue, error) => (
                                  <MUI.FormControlLabel
                                    label={v2.name}
                                    control={
                                      <MUI.Checkbox
                                        checked={value}
                                        onChange={(evt) =>
                                          setValue(evt.target.checked)
                                        }
                                      />
                                    }
                                  />
                                )}
                              />
                            );
                          })}
                        </MUI.Stack>
                        <MZ.InputControllerWidget
                          formController={formController}
                          name="outBenchs"
                          index={parseInt(k)}
                          initValue={true}
                          staticValue={v.id}
                          inputField={(value, setValue, error) => (
                            <MUI.FormControlLabel
                              label={MZ.T("other-bechmarks")}
                              control={
                                <MUI.Checkbox
                                  checked={value}
                                  onChange={(evt) =>
                                    setValue(evt.target.checked)
                                  }
                                />
                              }
                            />
                          )}
                        />
                      </MUI.AccordionDetails>
                    </MUI.Accordion>
                  );
                })
              : null}
          </MUI.Grid>
        )}

        {RouterParams.portal === "outlet" ? null : (
          <MUI.Grid item xs={12}>
            <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
          </MUI.Grid>
        )}
        <MUI.Grid item xs={12}>
          <MZ.GroupControllerWidget
            formController={formController}
            name="weekdays"
            inputField={(values) => {
              let checks = MZ.CountIf(values, (k, v) => v === true);
              let count = Object.keys(values).length;
              return (
                <MUI.FormControlLabel
                  label={MZ.T("weekdays")}
                  control={
                    <MUI.Checkbox
                      checked={checks === count}
                      indeterminate={checks > 0 && checks < count}
                      onChange={(evt) =>
                        formController.setValues("weekdays", evt.target.checked)
                      }
                    />
                  }
                />
              );
            }}
          />
          <MUI.Stack
            direction="row"
            justifyContent="flex-start"
            flexWrap="wrap"
            sx={{ pl: 3 }}
          >
            {MZ.ForEach(
              [
                MZ.T("sunday"),
                MZ.T("monday"),
                MZ.T("tuesday"),
                MZ.T("wednesday"),
                MZ.T("thursday"),
                MZ.T("friday"),
                MZ.T("saturday"),
              ],
              (k, v) => (
                <MZ.InputControllerWidget
                  key={`filterWeekdays-${k}`}
                  formController={formController}
                  name="weekdays"
                  index={parseInt(k)}
                  initValue={true}
                  staticValue={k}
                  inputField={(value, setValue, error) => (
                    <MUI.FormControlLabel
                      label={v}
                      control={
                        <MUI.Checkbox
                          checked={value}
                          onChange={(evt) => setValue(evt.target.checked)}
                        />
                      }
                    />
                  )}
                />
              )
            )}
          </MUI.Stack>
        </MUI.Grid>
        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>
        <MUI.Grid item xs={12}>
          <MZ.GroupControllerWidget
            formController={formController}
            name="monthdays"
            inputField={(values) => {
              let checks = MZ.CountIf(values, (k, v) => v === true);
              let count = Object.keys(values).length;
              return (
                <MUI.FormControlLabel
                  label={MZ.T("days-of-month")}
                  control={
                    <MUI.Checkbox
                      checked={checks === count}
                      indeterminate={checks > 0 && checks < count}
                      onChange={(evt) =>
                        formController.setValues(
                          "monthdays",
                          evt.target.checked
                        )
                      }
                    />
                  }
                />
              );
            }}
          />
          <MUI.Stack
            direction="row"
            justifyContent="flex-start"
            flexWrap="wrap"
            sx={{ pl: 3 }}
          >
            {MZ.Generate(31, (i) => (
              <MZ.InputControllerWidget
                key={`filter-monthdays-${i}`}
                formController={formController}
                name="monthdays"
                index={i}
                initValue={true}
                staticValue={`${i + 1}`}
                inputField={(value, setValue, error) => (
                  <MUI.FormControlLabel
                    label={`${i + 1}`}
                    control={
                      <MUI.Checkbox
                        checked={value}
                        onChange={(evt) => setValue(evt.target.checked)}
                      />
                    }
                  />
                )}
              />
            ))}
          </MUI.Stack>
        </MUI.Grid>
      </MUI.Grid>
    </MyFormDialog>
  );
};

// get transactions
async function dependantsAPI() {
  try {
    //========================= validate data
    let fData = new FormData();
    fData.set("UID", MyAppM.UIDD.UID);
    //========================= request
    return await MyAppM.exabyteRequest(
      "client/scheduled-reports/dependants",
      fData
    );
  } catch (err) {
    return MZ.Error(err);
  }
}

// get transactions
async function getAPI() {
  try {
    //========================= validate data
    let fData = new FormData();
    fData.set("UID", MyAppM.UIDD.UID);
    //========================= request
    return await MyAppM.exabyteRequest("client/scheduled-reports/get", fData);
  } catch (err) {
    return MZ.Error(err);
  }
}
